"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const toolkit_1 = require("@reduxjs/toolkit");
const utils_1 = require("../../../utils/utils");
const financialBankAccountSlice_1 = require("../../profile/financialBankAccount.tsx/financialBankAccountSlice");
const store_1 = require("../../../store");
const multiDocumentManager_1 = __importStar(require("../../../components/documentUpload/multiDocumentManager"));
const banks_1 = __importDefault(require("../../../utils/banks"));
const input_1 = __importStar(require("../../../components/input/input"));
const analytics_1 = require("../../../utils/analytics/analytics");
const ManualBankStatements = ({ errors, setErrors, setCanContinueProcess }) => {
    const dispatch = (0, store_1.useAppDispatch)();
    const { logEventWithExtraProperties } = (0, analytics_1.useAnalytics)();
    // User info
    const [bankName, setBankName] = (0, react_1.useState)('');
    const [bankAccountName, setBankAccountName] = (0, react_1.useState)('');
    const [bankAccountNumber, setBankAccountNumber] = (0, react_1.useState)('');
    const [documents, setDocuments] = (0, react_1.useState)([]);
    // VALIDATE FINANCIAL BANK ACCOUNT FORM DATA - SAVE
    const savePrimaryBankAccount = async () => {
        const payload = {
            bank_name: bankName,
            bank_account_name: bankAccountName.toString(),
            bank_account_number: bankAccountNumber.toString(),
        };
        // Add bank account
        const result = await dispatch((0, financialBankAccountSlice_1.submitFinancialAddBankAccount)(payload));
        logEventWithExtraProperties('api_call', {
            name: 'add_bank_account',
            status: 'submitted',
            location: 'screen_ManualBankStatements',
        });
        if ((0, toolkit_1.isFulfilled)(result)) {
            logEventWithExtraProperties('api_call', {
                name: 'add_bank_account',
                status: 'success',
                location: 'screen_ManualBankStatements',
            });
            setErrors(undefined);
            setCanContinueProcess(true);
            return result.payload.details_bank_id;
        }
        logEventWithExtraProperties('api_call', {
            name: 'add_bank_account',
            status: 'fail',
            location: 'screen_ManualBankStatements',
        });
        setErrors(result.payload);
        setCanContinueProcess(false);
        return null;
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PICKER, label: "Choose Bank", choices: banks_1.default, value: bankName, setValue: setBankName, error: (0, utils_1.getError)('bank_name', errors) }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_TEXT, label: "Account name", placeholder: "Account name", setValue: setBankAccountName, error: (0, utils_1.getError)('bank_account_name', errors), value: bankAccountName }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_NUMBER, label: "Account number", placeholder: "Account number", setValue: setBankAccountNumber, error: (0, utils_1.getError)('bank_account_number', errors), value: bankAccountNumber }),
        react_1.default.createElement(multiDocumentManager_1.default, { documents: documents, setDocuments: setDocuments, mimeType: ['application/pdf'], requirements: ['12 MONTHS OF BANK STATEMENT'], screenName: "manualStatement", askPassword: true, uploadTo: multiDocumentManager_1.submitStatement, deleteDocument: financialBankAccountSlice_1.deleteStatement, preUploadForBankAccountId: savePrimaryBankAccount })));
};
exports.default = ManualBankStatements;
